<template>
  <div>
    <AdminMasterLayout>
      <!--OVERVIEWSECTION -->

      <section class="overhead">
        <div class="overhead-1 row justify-content-between my-3 wallet-header">
          <div class="col-md-6 col-sm-12">
            <h5 class="pt-3">{{ $t("text.iDashboard.overview") }}</h5>
          </div>
          <div class="col-md-4 col-sm-12 date_picker_m">
            <div class="">
              <vue-ctk-date-time-picker
                v-model="dateRange"
                :max-date="maxDate"
                :range="true"
                :autoClose="true"
                :locale="this.$root.$i18n.locale"
                color="#370F70"
                format="DDMMYYYY"
                formatted="DD/MM/YYYY"
                :label="$t('text.calendar.dateRange')"
              />
            </div>
          </div>
        </div>
      </section>

      <!-- FIRST SECTION -->
      <!-- LOADER -->
      <section
        class="row card-loader-wrapper ml-1"
        style="width: 98%"
        v-if="showLoader"
      >
        <div
          class="col-md-3 position-relative mb-2"
          v-for="(c, i) in 4"
          :key="i"
        >
          <div class="card-loader"></div>
        </div>
      </section>
      <!-- END LOADER -->

      <section class="mt-3 full__row_section" v-if="!showLoader">
        <div class="dashboard__cards__wrapper row justify-content-between">
          <div class="dashboard__card small_card col-md-3 col-sm-12">
            <div
              class="small__card_content_wrapper row justify-content-between"
            >
              <div class="car_content_flex_wrapper col-3 mt-5">
                <img src="@/assets/img/042-electric_tower.svg" width="40px" />
              </div>
              <div class="col-9">
                <h4 class="dashboard__card__header">
                  {{ $t("text.iDashboard.totalHoursOnPowerGrid") }}
                </h4>

                <div class="mt-1">
                  <h3 class="dashboard__card__header_bottom">
                    {{ totalPowerHours }}
                  </h3>
                  <span>{{ $t("text.iDashboard.hours") }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="dashboard__card small_card col-md-3 col-sm-12">
            <div
              class="small__card_content_wrapper row justify-content-between"
            >
              <div class="car_content_flex_wrapper col-3 mt-5">
                <img src="@/assets/img/002-energy.svg" width="40px" />
              </div>
              <div class="col-9">
                <h4 class="dashboard__card__header">
                  {{ $t("text.iDashboard.totalHours") }}
                </h4>

                <div class="mt-1">
                  <h3 class="dashboard__card__header_bottom">
                    {{ totalGeneratorHours }}
                  </h3>
                  <span>{{ $t("text.iDashboard.hours") }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="dashboard__card small_card col-md-3 col-sm-12">
            <div
              class="small__card_content_wrapper row justify-content-between"
            >
              <div class="car_content_flex_wrapper col-3 mt-5">
                <img src="@/assets/img/Vector.svg" width="40px" />
              </div>
              <div class="col-9">
                <h4 class="dashboard__card__header">
                  {{ $t("text.iDashboard.fuelVolume") }}
                </h4>
                <div class="mt-3">
                  <h3 class="dashboard__card__header_bottom">
                    {{ totalFuelVol }}
                  </h3>
                  <span> {{ $t("text.iDashboard.litres") }}</span>
                </div>
              </div>
            </div>
          </div>

          <div
            class="dashboard__card large_card indus_back_img col-md-3 col-sm-12"
            :style="[
              {
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
              },
            ]"
          >
            <div class="row align-items-center larg_inner__row">
              <div class="col-md-4 larg_inner__row_left">
                <img src="@/assets/img/money (3).svg" width="70" />
              </div>
              <div class="col-md-8 larg_inner__row_right">
                <div>
                  <small class="text-white">{{
                    $t("text.iDashboard.companyWallet")
                  }}</small>
                </div>
                <h5 class="text-white mt-4">
                  <img
                    src="@/assets/img/naira.svg"
                    alt="wallet"
                    class="mr-1 wallet-img"
                    width="15"
                  />

                  {{ companyCumulativeWallet }}
                </h5>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- SECOND SECTION -->

      <section
        class="mt-3 full__row_section my-3 mt-5 first-section justify-content-around"
      >
        <!-- LOADER -->
        <div
          class="showLoaderDiv charts__loader w-full"
          style="width: 100%; height: 100%"
          v-if="showLoader"
        >
          <div :class="showLoader ? 'loading' : null"></div>
        </div>
        <!-- END LOADER -->

        <!-- DAILY USAGE CHART -->
        <div class="row mt-3 dashboard_second_row_right" v-if="!showLoader">
          <div class="consumption_chart col-md-8">
            <div v-show="consumptionstatus === 'daily'">
              <highcharts
                :options="dailyUsageChart"
                class=""
                style="padding-top: 60px"
              ></highcharts>
            </div>
          </div>

          <div
            class="col-md-3 num-tank bg-white px-3 py-5 text-center"
            v-if="!showLoader"
          >
            <h5 class="mb-5">{{ $t("text.iDashboard.tankPercentage") }}</h5>

            <h2 class="mb-5">{{ lowTanks }}</h2>
            <router-link
              :to="{
                name: 'industrial_admin_report',
                query: { companyID: this.companyID, tab: 'tanks' },
              }"
            >
              <button>{{ $t("text.iDashboard.allTanks") }}</button>
            </router-link>
          </div>
        </div>
      </section>

      <section v-if="consumption">
        <div class="col-md-12 top_consumption bg-white my-3" v-if="!showLoader">
          <div class="container">
            <h4 class="font-weight-bold text-xl mb-3 mt-5">
              {{ $t("text.iDashboard.branchConsumption") }}
            </h4>

            <!-- TABLE -->
            <section class="my-5 full__row_section table-section mx-auto">
              <ejs-grid
                v-show="!showLoader"
                ref="dataGrid"
                :dataSource="consumption"
                :created="refreshGrid"
                :allowPaging="true"
                :allowSorting="true"
                :pageSettings="pageSettings"
                :toolbar="toolbar"
                :searchSettings="search"
                :allowExcelExport="true"
                :allowPdfExport="true"
                :toolbarClick="toolbarClick"
                :locale="usedLang"
              >
                <e-columns>
                  <e-column
                    field="branchName"
                    width="180"
                    :headerText="$t('text.iDashboard.site')"
                  ></e-column>
                  <e-column
                    field="powerGridHours"
                    format="N2"
                    width="180"
                    :headerText="$t('text.iDashboard.power')"
                  ></e-column>
                  <e-column
                    field="generatorHours"
                    format="N2"
                    width="180"
                    :headerText="$t('text.iDashboard.generator')"
                  ></e-column>
                  <e-column
                    field="tankConsumption"
                    format="N2"
                    width="180"
                    :headerText="$t('text.iDashboard.fuel')"
                  ></e-column>
                </e-columns>
              </ejs-grid>

              <TableLoader :showLoader="showLoader"></TableLoader>
            </section>

            <!-- SECTION 3 Total Branch Consumption -->
            <!-- <div class="table-responsive">
              <table class="table table-borderless table-hover">
                <thead>
                  <tr>
                    <th colspan="2"></th>
                    <th scope="col">{{ $t("text.iDashboard.power") }}</th>
                    <th scope="col">{{ $t("text.iDashboard.generator") }}</th>
                    <th scope="col">{{ $t("text.iDashboard.fuel") }}</th>
                  </tr>
                </thead>
                <tbody v-if="consumption.length > 0">
                  <tr v-for="branch in consumption" :key="branch.id">
                    <th colspan="2" class="col-lg-4 col-md-3 col-sm-3">
                      <div>
                        <p>{{ branch.branchName }}</p>
                      </div>
                    </th>

                    <td>
                      {{
                        branch.powerGridHours.toLocaleString(undefined, {
                          maximumFractionDigits: 2,
                          minimumFractionDigits: 2,
                        })
                      }}
                    </td>

                    <td>
                      {{
                        branch.generatorHours.toLocaleString(undefined, {
                          maximumFractionDigits: 2,
                          minimumFractionDigits: 2,
                        })
                      }}
                    </td>

                    <td>
                      {{
                        branch.tankConsumption.toLocaleString(undefined, {
                          maximumFractionDigits: 2,
                          minimumFractionDigits: 2,
                        })
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div> -->

            <router-link
              :disabled="isDisabled"
              :to="{
                name: 'industrial_admin_branches',
                query: { companyID: this.companyID },
              }"
              class="table-link mt-2"
            >
              <button>{{ $t("text.iDashboard.allBranchConsumption") }}</button>
            </router-link>
          </div>
        </div>
      </section>
    </AdminMasterLayout>
  </div>
</template>

<script>
import AdminMasterLayout from "@/views/Industrial/AdminMasterLayout.vue";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import { Chart } from "highcharts-vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import { VueApexCharts } from "apexcharts";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  title: "Dashboard:: Epump Industrial Portal",
  name: "DashboardHome",
  components: {
    AdminMasterLayout,
    Highcharts: Chart,
    VueApexCharts,
    VueperSlides,
    VueperSlide,
    PulseLoader,
    TableLoader,
  },
  data() {
    return {

      // table variables
      usedLang: this.$store.getters.getLanguage,
      pageSettings: { pageSizes: [12, 50, 100, 200], pageCount: 4 },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },


      lowTanks: "0",
      changing: true,
      totalPowerHours: "0",
      totalGeneratorHours: "0",
      totalFuelVol: "0",
      consumption: [],
      companyID: localStorage.getItem("companyID")
        ? localStorage.getItem("companyID")
        : null,
      companyCumulativeWallet: 0,
      showLoader: true,
      isDisabled: true,
      tankStartDate: this.$moment().format("MMMM D, YYYY"),
      hourlyConsumptionStartDate: this.$moment().format("MMMM D, YYYY"),
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      // tankDateRange: this.tankStartDate,
      hourlyPoweerConsumptionDateRange: this.hourlyConsumptionStartDate,
      totalGenHours: 0,
      totalPgHours: 0,
      totalPGHours: 0,
      tanks: [],
      powerHoursConsumedDateRange: {
        start: this.powerHoursConsumedStartDate,
        end: this.powerHoursConsumedEndDate,
      },
      powerHoursConsumedEndDate: this.$moment().format("MMMM D, YYYY"),
      powerHoursConsumedStartDate: this.$moment()
        .subtract(0, "days")
        .format("MMMM D, YYYY"),
      startDate: this.$moment().subtract(7, "days").format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      totalVolumeSold: 0,
      tankSale: { pms: 0, ago: 0, dpk: 0, lpg: 0 },
      tankSaleStartDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      tankSalesEndDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      walletTransactionStartDate: this.$moment()
        .subtract(30, "days")
        .format("D-M-YYYY"),
      walletTransactionEndDate: this.$moment().format("D-M-YYYY"),
      pluginStartDate: this.$moment().subtract(7, "days").format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      tankDisplacementStartDate: this.$moment().format("D-M-YYYY"),
      hourlyPowerConsumedStartDate: this.$moment().format("D-M-YYYY"),
      powerSource: "",
      industryBranch: null,
      industryBranchId: null,
      walletBalance: 0,
      consumptionstatus: "daily",
      year: "2020",
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      dailyUsageChart: {
        title: {
          text: this.$t("text.iMarkMaintenance.conGraph"),
        },
        chart: {
          height: "50%",
          type: "column",
        },

        xAxis: {
          categories: [],
          crosshair: false,
        },
        yAxis: {
          min: 0,
          title: {
            text: this.$t("text.iDashboard.dailyUsageHours"),
          },
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        series: [],
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                chart: {
                  height: 300,
                },
                subtitle: {
                  text: null,
                },
                navigator: {
                  enabled: false,
                },
              },
            },
          ],
        },
      },
    };
  },
  created() {
    if (
      !this.userInfo.roles.includes("SupportAdmin") ||
      this.userInfo.roles.includes("PartnerAdmin") ||
      this.userInfo.roles.includes("IndustryAdmin")
    ) {
      this.getCompany();
    }
    if (this.$route.query.companyID) {
      this.fetchData();
    }

    this.hourlyPoweerConsumptionDateRange = this.hourlyPowerConsumedStartDate;
    this.$eventHub.$on("industryBranch", (industryBranch) => {
      this.industryBranch = industryBranch;
      document.title = `Industry Dashboard - ${industryBranch.name}`;
    });
    this.dateRange.start = this.pluginStartDate;
    this.dateRange.end = this.pluginEndDate;
  },
  watch: {
    hourlyPoweerConsumptionDateRange: function (newDate) {
      if (newDate) {
        this.hourlyConsumptionStartDate = this.$moment(
          newDate,
          "DD-MM-YYYY"
        ).format("YYYY-MM-DD");
      }
    },

    powerHoursConsumedDateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.powerHoursConsumedStartDate = this.$moment(
          newRange.start,
          "DD-MM-YYYY"
        ).format("YYYY-MM-DD");
        this.powerHoursConsumedEndDate = this.$moment(
          newRange.end,
          "DD-MM-YYYY"
        ).format("YYYY-MM-DD");
        this.getCompanyTotalPowerUseDetails();
      }
    },
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "YYYY-MM-DD"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "YYYY-MM-DD"
        );
        this.getCompanyPowerUseDailyUsage(this.companyID);
        this.getCompanyTotalPowerUseDetails();
        this.getBranchConsumption(this.companyID);
        this.getCompanyTotalFuelUse();
      }
    },

    companyID: function (newID, oldID) {
      localStorage.setItem("companyID", newID);
    },
  },
  mounted() {},
  computed: {
    userInfo() {
      const user = localStorage.getItem("userDetails")
        ? JSON.parse(localStorage.getItem("userDetails"))
        : null;

      if (user) {
        if (!user.roles) {
          if (user.role) {
            user.roles = user.role.split(",");
            localStorage.setItem("userDetails", JSON.stringify(user));
          }
        }
      }
      return user;
    },
  },
  methods: {
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    fetchData() {
      this.getCompanyTotalPowerUseDetails();
      this.getTotalWalletBalance(this.$route.query.companyID);
      this.getCompanyPowerUseDailyUsage(this.$route.query.companyID);
      this.getCompanyTotalFuelUse();
      this.getCompanyLowTanks();
      this.getBranchConsumption(this.$route.query.companyID);
      this.showLoader = false;
    },
    changeYear(e) {
      this.year = e.target.value;
      this.getMonthlyUsageChart();
    },

    changeConsumptionStatus(e) {
      if (e.target.value === "hourly") {
        this.consumptionstatus = "hourly";
      } else if (e.target.value === "daily") {
        this.consumptionstatus = "daily";
      } else {
        this.consumptionstatus = "monthly";
      }
    },
    getCompany() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/MyCompanies`,
          configObject.authConfig()
        )
        .then((response) => {
          this.showLoader = false;
          this.companyID = response.data[0].id;
          this.$eventHub.$emit("company", response.data[0]);
          this.getCompanyTotalPowerUseDetails();
          this.getTotalWalletBalance(response.data[0].id);
          this.getCompanyPowerUseDailyUsage(response.data[0].id);
          this.getCompanyTotalFuelUse();
          this.getCompanyLowTanks();
          this.getBranchConsumption(response.data[0].id);
        })
        .catch((error) => {});
    },

    getTotalWalletBalance(companyID) {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Industrial/TotalRemisWallet/${
            this.$route.query.companyID
              ? this.$route.query.companyID
              : companyID
          }`,
          configObject.authConfig()
        )
        .then((res) => {
          this.companyCumulativeWallet = res.data.balance.toLocaleString(
            undefined,
            {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }
          );
          this.$eventHub.$emit("company", response.data[0]);
        })
        .catch((error) => {});
    },

    convertTime(time) {
      let newTime = time.split(":");
      let seconds = Number(newTime[2]).toFixed(2);
      return `${newTime[0]}: ${newTime[1]}: ${seconds}`;
    },

    //COMPANY TOTAL POWER USE
    getCompanyTotalPowerUseDetails() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/IndustrialDashboard/PowerUse/${
            this.$route.query.companyID
              ? this.$route.query.companyID
              : this.companyID
          }?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((res) => {
          this.totalPowerHours = res.data[0].hours.toFixed(2);
        })
        .catch((error) => {});
    },

    //COMPANY TOTAL FUEL USE
    getCompanyTotalFuelUse() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/IndustrialDashboard/DayFuelUse/${
            this.$route.query.companyID
              ? this.$route.query.companyID
              : this.companyID
          }?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((res) => {
          this.totalFuelVol = res.data.vol.toLocaleString("en", {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
          });
        })
        .catch((error) => {});
    },

    // DAILY USE GRAPH
    getCompanyPowerUseDailyUsage(companyId) {
      companyId === undefined ? companyId : this.companyID;

      this.axios
        .get(
          `${configObject.apiBaseUrl}/IndustrialDashboard/PowerUseDaily/${
            this.$route.query.companyID
              ? this.$route.query.companyID
              : companyId
          }?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((res) => {
          res.data.forEach((x) => {
            let date = new Date(x.date);
            const newDate = this.$moment(date).format("MMMM D");
            x.date = newDate;
          });
          let gen = res.data.filter((el) => el.source === "Generator");
          let powerGrid = res.data.filter((el) => el.source === "Power Grid");
          let vol = res.data.filter((el) => el.source === "Volume Use");
          let powerArr = powerGrid.map((el) => {
            return Number(el.hours.toFixed(2));
          });
          let genArr = gen.map((el) => {
            return Number(el.hours.toFixed(2));
          });
          let volArr = vol.map((el) => {
            return Number(el.hours.toFixed(2));
          });
          let totalGenHours = gen.reduce((prev, cur) => {
            return prev + cur.hours;
          }, 0);
          this.totalGeneratorHours = totalGenHours.toFixed(2);

          let cats = [];
          gen.forEach((el) => {
            cats.push(el.date);
          });
          let genSeries = [
            {
              name: this.$t("text.iReport.generator"),
              data: genArr,
              color: "#FCD462",
            },
          ];

          let powerSeries = [
            {
              name: this.$t("text.iReport.powerGrid"),
              data: powerArr,
              color: "#370F70",
            },
          ];

          // vol.forEach((el) => {
          //   if (el.hours < 0) {
          //     el.hours = 0;
          //   }
          //   const newArrz = el.hours.toFixed(2);
          //   // console.log(`vol array - ${newArrz}`);
          //   volArr.push(parseFloat(newArrz));
          // });
          // let volSeries = [
          //   {
          //     name: this.$t("text.iReport.volUsed"),
          //     data: volArr,
          //     color: "red",
          //   },
          // ];

          this.dailyUsageChart.series = [
            // ...volSeries,
            ...genSeries,
            ...powerSeries,
          ];
          this.dailyUsageChart.xAxis.categories = cats;
        })
        .catch((error) => {});
    },

    //TANKS WITH LESS THAN 30%
    getCompanyLowTanks() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Industrial/Company/TanksLessThan30/${
            this.$route.query.companyID
              ? this.$route.query.companyID
              : this.companyID
          }`,
          configObject.authConfig()
        )
        .then((res) => {
          this.lowTanks = res.data.length;
        })
        .catch((error) => {});
    },

    // GET TOTAL BRANCH CONSUMPTION
    getBranchConsumption(companyID) {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Industrial/PowerUse/Company/${
            this.$route.query.companyID
              ? this.$route.query.companyID
              : companyID
          }?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((res) => {
          let consumption = res.data.sort(
            (a, b) => b.generatorHours - a.generatorHours
          );
          this.consumption = consumption.slice(0, 5);
        });
    },
  },
};
</script>

<style scoped>
wallet-header {
  width: 90%;
  margin: auto auto;
}

.overhead {
  width: 95%;
  margin: auto auto;
}
.overhead h5 {
  color: #2b2b2b;
  font-size: 35px;
}
.small_card {
  align-items: normal;
}
.small__card_content_wrapper {
  flex-direction: row;
  width: 110%;

  margin: auto auto;
  align-items: center;
}
.dashboard__card__header {
  font-size: 14px;
  font-weight: 700;
  margin-top: 10px;
}

.car_content_flex_wrapper {
  margin-top: 30px;

  width: 77px;
  height: 64px;
}

.dashboard__cards__wrapper {
  width: 100% !important;
  margin: auto auto !important;
}
.small__card_content_wrapper span {
  font-family: Poppins;
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: -0.01em;
  text-align: left;
}
.consumption_chart {
  height: 450px !important;
  width: 100%;
  background-color: white;
}

.num-tank {
  margin-left: 30px;
  border-radius: 20px;
}

.num-tank h5 {
  font-size: 1.2em;
}

.num-tank h2 {
  font-size: 9em;
  color: #f21717;
}

@media only screen and (max-width: 500px) {
  .consumption_chart {
    display: block;
  }

  /* .dashboard__card{
    height:400px;
  } */
}

@media only screen and (max-width: 1378px) {
  .small_card h4 {
    font-size: 12px !important;
  }
  .small_card h3 {
    font-size: 14px !important;
  }
  /* .dashboard__card {
    height: 160px;
  } */
  .car_content_flex_wrapper {
    width: 34px;
    height: 55px;
    border-radius: 15px;
  }
  .car_content_flex_wrapper img {
    width: 20px;
  }
}

.table span {
  font-size: 12px;
  color: grey;
  font-weight: lighter;
}

thead {
  border-bottom: 1px black solid;
}
.top_consumption button,
.num-tank button {
  padding: 10px 20px;
  border: 1px solid #494d6a;
  background-color: transparent;

  font-size: 14px;
  border-radius: 5px;
}
.table-link {
  position: absolute;
  bottom: 0px;
  left: 50%;
  transform: translate(-50%, -50%);
}

.top_consumption {
  border-radius: 30px;
}

.table-responsive {
  margin-bottom: 80px;
}
</style>
